export default __webpack_public_path__ + "static/media/img2.0de4fcd1.png";